<template>
  <div>
    <div class="m-b-5 ovf-hd">
      <div class="fl m-r-30">
        <el-button size="small" type="success" @click="$router.push({ name: 'companyAdd' })"><i class="el-icon-plus"></i>&nbsp;&nbsp;添加企业</el-button>
      </div>
      <div class="fl w-400">
        <el-input placeholder="请输入企业号/联系人/电话/邮箱/企业信息等" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    style="width: 100%"
    border
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="company_code"
      label="企业号"
      fixed
      width="100">
      </el-table-column>
      <el-table-column
      prop="company_name"
      label="企业名称"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="rise_company_name"
      label="企业全称"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="rise_discern_code"
      label="纳税人识别号"
      width="200">
      </el-table-column>
      <el-table-column
      prop="rise_company_addr"
      label="公司注册地址"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="rise_company_phone"
      label="公司联系电话"
       width="130"
       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="rise_bank_name"
      label="开户行名称"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="rise_bank_code"
      label="开户银行账号"
      width="180"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="company_user"
      label="企业联系人"
      width="100"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="company_phone"
      label="联系人电话"
      width="150"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="company_email"
      label="企业邮箱"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      label="状态">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.status ==1" class="success_status">正常</span>
            <span v-else-if = "scope.row.status ==0" class="goon_status">{{ scope.row.status | status }}</span>
            <span v-else-if = "scope.row.status ==-1" class="error_status">{{ scope.row.status | status }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="操作"
      fixed="right"
      width="280">
        <template scope="scope">
          <div>
            <span>
              <!-- <el-button size="small" type="primary" @click="$router.push({ name: 'company_userList', params: { id: scope.row.id }})">员工</el-button>
              <el-button size="small" type="primary" @click="$router.push({ name: 'company_billList', params: { id: scope.row.id }})">报销</el-button>
              <el-button size="small" type="primary" @click="$router.push({ name: 'company_bill_folderList', params: { id: scope.row.id }})">发票</el-button> -->
              <el-button size="small" type="primary" @click="$router.push({ name: 'companyEdit', params: { id: scope.row.id }})">编辑</el-button>
              <!-- <el-button size="small" type="danger" @click="confirmDelete(scope.row)">删除</el-button> -->
              <el-button size="small" type="danger" @click="confirmset(scope.row)">重置</el-button>
              <el-button size="small" type="primary" @click="$router.push({ name: 'company_userList', params: { id: scope.row.id }})">员工</el-button>
              <el-button size="small" type="success" @click="$router.push({ name: 'company_Index', params: { id: scope.row.id }})">统计</el-button>
              <!-- <el-popover
                placement="left"
                width="200"
                trigger="click">
                <div>
                  <el-button size="small" type="primary" @click="$router.push({ name: 'company_billList', params: { id: scope.row.id }})">报销</el-button>
                  <el-button size="small" type="primary" @click="$router.push({ name: 'company_bill_folderList', params: { id: scope.row.id }})">发票</el-button>
                </div>
                <el-button slot="reference" size="small" type="text" class="action_more_button"><i class="iconfont action_more">&#xe650;</i></el-button>
              </el-popover> -->
            </span>
            <span>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <btnGroup :selectedData="multipleSelection" :type="'company'"></btnGroup>
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import btnGroup from '../../../Common/btn-group.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        multipleSelection: [],
        limit: 15
      }
    },
    methods: {
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        console.log(val)
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      confirmDelete(item) {
        this.$confirm('确认删除该企业?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _g.openGlobalLoading()
          this.apiDelete('admin/company/', item.id).then((res) => {
            _g.closeGlobalLoading()
            this.handelResponse(res, (data) => {
              _g.toastMsg('success', '删除成功')
              setTimeout(() => {
                _g.shallowRefresh(this.$route.name)
              }, 1500)
            })
          })
        }).catch(() => {
          // catch error
        })
      },
      confirmset(item) {
        this.$prompt('请输入登录密码', '重置企业基础数据(' + item.company_code + ')', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          _g.openGlobalLoading()
          this.apiGet('admin/company/set_delete?id=' + item.id + '&pwd=' + value).then((res) => {
            _g.closeGlobalLoading()
            this.handelResponse(res, (data) => {
              _g.toastMsg('success', '重置成功')
              setTimeout(() => {
                _g.shallowRefresh(this.$route.name)
              }, 1500)
            })
          })
        }).catch(() => {
        })
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet('admin/company', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('company-save')
      },
      editShow() {
        return _g.getHasRule('company-update')
      },
      deleteShow() {
        return _g.getHasRule('company-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?dc87de4a